var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-list-square mb-2"},_vm._l((_vm.items),function(item,index){return _c('b-button',{key:index,staticClass:"square-text mr-3 mb-2",class:item.background,on:{"click":function($event){$event.preventDefault();return (() => _vm.$emit('filterEvents', item)).apply(null, arguments)}}},[_vm._v(" "+_vm._s(item.title)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }